/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function WmFirmwareController($rootScope, $mdDialog, $document, $scope, $translate, types, toast,
                                             gatewayCommandService, gatewayId, fileTransferService) {
    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;
        vm.types = types;
        vm.decompressFile = false;
        vm.remoteUrl = null;
        vm.remoteUserName = null;
        vm.remotePassword = null;

        vm.close = close;
        vm.fileAdded = fileAdded;
        vm.uploadAndInstall = uploadAndInstall;
        vm.wipeUploadDirectory = wipeUploadDirectory;
        vm.upgradeFirmware = upgradeFirmware;
        vm.uploadRemote = uploadRemote;

        vm.loading = function() {
            return $rootScope.loading;
        };
    };

    function close() {
        $mdDialog.cancel();
    }

    function fileAdded($file) {
        fileTransferService.fileAdded($file, $scope).then(
            (fileInfo) => {
                vm.importData = fileInfo.importData;
                vm.fileName = fileInfo.fileName;
                vm.fileSize = fileInfo.fileSize;
            }
        );
    }

    function uploadAndInstall() {
        var fileInfo = {
            importData: vm.importData,
            fileName: vm.fileName,
            fileSize: vm.fileSize,
            decompressFile: vm.decompressFile,
            isModemFw: true
        };

        var toastParent = angular.element('#tk-wm-firmware-dialog', $document);

        fileTransferService.fileUpload(vm.gatewayId.id, fileInfo).then(
            (result) => {
                vm.importData = null;
                vm.fileName = null;
                vm.fileSize = null;
                vm.decompressFile = false;

                if (result === 'ok') {
                    gatewayCommandService.executeCommand(vm.gatewayId.id,
                        types.wirelessModemCommand.installWmLocalFirmware.value, {}).then(
                        (response) => {
                            if (response.status === 'started') {
                                toast.showInfo($translate.instant('wireless-modem.fw-update-alert'), null, toastParent, 'bottom left');
                            } else {
                                toast.showError(response.status, toastParent, 'bottom left');
                            }
                        },
                        (rejection) => {
                            toast.showError(rejection.data, toastParent, 'bottom left');
                        }
                    );
                } else {
                    toast.showInfo(result, null, toastParent, 'bottom left');
                }
            },
            (rejection) => {
                toast.showError(rejection.data, toastParent, 'bottom left');
            }
        );
    }

    function wipeUploadDirectory() {
        var toastParent = angular.element('#tk-wm-firmware-dialog', $document);
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.wipeUploadDirectory.value, {}).then(
            (response) => {
                if (response.error) {
                    if (angular.equals(response.error, types.gatewayCommandNotSupported.value)) {
                        toast.showError($translate.instant("gateway-command.not-supported"), toastParent, 'bottom left');
                    }
                } else {
                    toast.showInfo(response.status, null, toastParent, 'bottom left');
                }
            },
            (rejection) => {
                toast.showError(rejection.data, toastParent, 'bottom left');
            }
        );
    }

    function upgradeFirmware() {
        var toastParent = angular.element('#tk-wm-firmware-dialog', $document);
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.upgradeWmFirmware.value, {}).then(
            (response) => {
                if (response.error) {
                    if (angular.equals(response.error, types.gatewayCommandNotSupported.value)) {
                        toast.showError($translate.instant("gateway-command.not-supported"), toastParent, 'bottom left');
                    }
                } else {
                    toast.showInfo(response.status, null, toastParent, 'bottom left');
                }
            },
            (rejection) => {
                toast.showError(rejection.data, toastParent, 'bottom left');
            }
        );
    }

    function uploadRemote() {
        var remoteInfo = {
            url: vm.remoteUrl,
            userName: vm.remoteUserName,
            password: vm.remotePassword
        };

        var toastParent = angular.element('#tk-wm-firmware-dialog', $document);
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.uploadRemoteWmFirmware.value, remoteInfo).then(
            (response) => {
                vm.remoteUrl = null;
                vm.remoteUserName = null;
                vm.remotePassword = null;

                if (response.error) {
                    if (angular.equals(response.error, types.gatewayCommandNotSupported.value)) {
                        toast.showError($translate.instant("gateway-command.not-supported"), toastParent, 'bottom left');
                    }
                } else {
                    toast.showInfo(response.status, null, toastParent, 'bottom left');
                }
            },
            (rejection) => {
                toast.showError(rejection.data, toastParent, 'bottom left');
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/wm-firmware/wm-firmware.controller.js